import api from './axios';
import { User } from '../types';

export const usersApi = {
  getAll: () => api.get<User[]>('/users'),

  // Mozos activos (id + nombre) para asignar la comanda. Disponible para cajero/mozo.
  getMozos: () => api.get<Array<{ id: number; fullName: string }>>('/users/mozos'),

  getById: (id: number) => api.get<User>(`/users/${id}`),

  create: (data: { email: string; fullName: string; password: string; role: string }) =>
    api.post<User>('/users', data),

  update: (id: number, data: Partial<User & { password?: string }>) =>
    api.put<User>(`/users/${id}`, data),

  delete: (id: number) => api.delete(`/users/${id}`),
};
